import { render } from "./VSkeleton.vue?vue&type=template&id=7454b46e"
import script from "./VSkeleton.vue?vue&type=script&lang=js"
export * from "./VSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__